import { createContext } from "react";

export const CommLogDispatchContext = createContext();
